<template>
    <div>
        <el-dialog class="close-private cps-dialog-icon-line-height" :visible.sync="visible" size="50%"
            :title="$t('listPage.text.delete')" :close-on-click-modal="false" :before-close="handleClose">
            <div class="i-text">
                <div class="tip-warning mb20 lh20">
                    <p class="caution"><span class="icon-caution"></span>
                        <span>{{ $t('create.text.caution') | withColon }}</span>
                    </p>
                    <p class="mt10">1、游戏服务器删除时，所绑定的弹性公网IP资源将不再继续保留，如需继续保留，请前往对应页面解绑资源，以免影响业务使用。</p>
                    <p class="mt5">2、游戏服务器删除后即游戏结束，若再次启动游戏需重新创建游戏服务器，先重新授权“Steam流式传输”, 再同步Steam存档进度，详见</p>
                    <a href="https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong" target="_blank">
                        操作指南
                    </a>
                </div>
            </div>
            <div class="delete-tip" v-html="$t('game.list.deleteTip', [rowInfo.name])">
            </div>
            <div class="confirm-tip"><input type="checkbox" v-model="sureDelete" id="sureCharge" class="sure-delete" />
                <label for="sureCharge">{{ $t('game.list.sureCharge') }}</label>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDel">{{ $t('privateNetInstance.cancel') }}</el-button>
                <el-button @click="sureDel" type="primary" :disabled="!sureDelete">
                    {{ $t('privateNetInstance.sure') }}
                </el-button>
            </div>
        </el-dialog>
        <jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="OperationConstant.DELETE"
            @success="onSuccess" @error="onError">
        </jcb-opt-protect>
    </div>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';

export default {
    name: 'DeleteInstance',
    mixins: [operationProtect],

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rowInfo: {
            type: Object,
            default: () => { }
        },
        pageSource: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 是否勾选了确认的checkbox
            sureDelete: false,
            // 操作保护弹框是否显示
            operationProtectVisible: false,
        };
    },
    computed: {
        OperationConstant: () => OperationConstant
    },
    methods: {
        handleClose() {
            this.sureDelete = false;
            this.$emit('update:visible', false);
        },
        /**
         * 取消删除操作
         */
        cancelDel() {
            this.handleClose();
        },
        /**
         * 确定删除打开操作保护
         */
        sureDel() {
            this.openOperationProtect(OperationConstant.DELETE, this.rowInfo, this.pageSource);
            this.handleClose();
        },
        /**
         * 删除游戏服务器
         * @param headers
         */
        deleteInstance(headers) {
            const params = {
                instanceId: this.rowInfo.instanceId,
                region: this.rowInfo.region,
                clientToken: this.clientToken
            };
            Ajax.post('/api/cps/instances/deleteGameInstance', params, { headers }).then(() => {
                this.$emit('refresh');
            }).finally(() => {
                this.handleClose();
            });
        },
    },

};
</script>

<style lang="scss">
.close-private {

    .tip-warning {
        background: #FFF2F0;
        border: 1px solid #FFCCC7;
        border-radius: 2px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
    }

    .reinstall-confirm-checkbox {
        margin-top: 30px;
        margin-bottom: -20px;

        .jc-checkbox__label {
            color: rgb(121, 121, 121)
        }
    }

    .caution {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #FF4D4F;
        letter-spacing: 0;
        line-height: 22px;
        font-weight: 400;
    }

    .icon-caution {
        margin-right: 5px;
        width: 14px;
        height: 14px;
        display: inline-block;
        background: url('~@/assets/img/game/attention-red.png') center center no-repeat;
        background-size: 100%;
    }

    .delete-tip {
        font-size: 12px;
        color: #333333;
        text-align: justify;
        line-height: 18px;
        font-weight: 400;
        margin-bottom: 15px;

        .label {
            font-weight: 500;
        }

    }

    .confirm-tip {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;

        .sure-delete {
            margin-right: 10px;
            width: 16px;
            height: 16px;
            border: 1px solid #979797;
            border-radius: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/game/DeleteInstance.vue